import React, { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

export interface WidgetSectionProps {
  title?: string
  children: ReactNode
  isLastSection?: boolean
  sx?: object
}

const WidgetSection = (props: WidgetSectionProps) => (
  <Box
    sx={theme => ({
      marginBottom: theme.spacing(props.isLastSection ? 0 : 3),
      ...props.sx,
    })}
  >
    {props.title && (
      <Typography
        sx={theme => ({
          marginBottom: theme.spacing(0.75),
          fontSize: '1rem',
          lineHeight: 1.125,
          fontWeight: 600,
          color: '#000000B2',
        })}
      >
        {props.title}
      </Typography>
    )}
    {props.children}
  </Box>
)

export default WidgetSection
